var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-button",
        {
          staticClass: "mr10",
          style: { color: _vm.effectiveMaintained ? "#67c23a" : "#f56c6c" },
          attrs: { type: "text", size: "small" },
          on: { click: _vm.openDialog },
        },
        [_vm._v(_vm._s(_vm.buttonText))]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: _vm.dialogWidth,
            "close-on-click-modal": false,
            "append-to-body": true,
            "modal-append-to-body": true,
            "lock-scroll": true,
            "custom-class": "multi-lang-maintain-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "lang-tabs",
                  model: {
                    value: _vm.activeLangCode,
                    callback: function ($$v) {
                      _vm.activeLangCode = $$v
                    },
                    expression: "activeLangCode",
                  },
                },
                _vm._l(_vm.editableLanguageList, function (lang) {
                  return _c("el-tab-pane", {
                    key: lang.langCode,
                    attrs: { name: lang.langCode, label: lang.langName },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "i18n-wrap" }, [
                _c(
                  "div",
                  { staticClass: "i18n-left" },
                  [
                    _vm._t("left", null, {
                      fieldItems: _vm.fieldItems,
                      languageList: _vm.languageList,
                      editableLanguageList: _vm.editableLanguageList,
                      activeLangCode: _vm.activeLangCode,
                      setActiveLangCode: _vm.setActiveLangCode,
                      defaultLangName: _vm.defaultLangName,
                      currentLangName: _vm.currentLangName,
                      getSourceValue: _vm.getSourceValue,
                      getCurrentValue: _vm.getCurrentValue,
                      setCurrentValue: _vm.setCurrentValue,
                      setSourceValue: _vm.setSourceValue,
                      sourceLangCode: _vm.sourceLangCode,
                      loading: _vm.loading,
                      bizType: _vm.bizType,
                      bizId: _vm.bizId,
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "i18n-right" },
                  [
                    _vm._t("right", null, {
                      fieldItems: _vm.fieldItems,
                      languageList: _vm.languageList,
                      editableLanguageList: _vm.editableLanguageList,
                      activeLangCode: _vm.activeLangCode,
                      setActiveLangCode: _vm.setActiveLangCode,
                      defaultLangName: _vm.defaultLangName,
                      currentLangName: _vm.currentLangName,
                      getSourceValue: _vm.getSourceValue,
                      getCurrentValue: _vm.getCurrentValue,
                      setCurrentValue: _vm.setCurrentValue,
                      setSourceValue: _vm.setSourceValue,
                      sourceLangCode: _vm.sourceLangCode,
                      loading: _vm.loading,
                      bizType: _vm.bizType,
                      bizId: _vm.bizId,
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              !_vm.fieldItems.length && !_vm.loading
                ? _c("div", { staticClass: "empty-tip" }, [
                    _vm._v("\n        暂无可维护的多语言字段\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saveLoading,
                  },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }